import React, { useEffect, useState } from "react";
import Head from "next/head";
import { AnyRecord } from "~/types/record";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";
import { NextPageContext } from "next";
import { BookingByTokenPage } from "~/components/BookingByTokenPage";
import { fetchScheduleConfig } from "~/components/BookingByTokenPage/fetchScheduleConfig";
import { PoweredByHeader } from "~/shared/PoweredByHeader";
import Script from "next/script";
import Spinner from "~/shared/Spinner";

type BookProps = {
    responseStatus: "ok" | "error";
    errorDescription?: string;
    token: string;
    fields: AnyRecord;
    schedulingConfig: {
        schedulingTimeCalculation: any;
        defaultSegment: any;
        contactIsUser: any;
        defaultSchedulingType: any;
        defaultBriefing: any;
        doNotShowInPlaceContactInfo: any;
        doNotShowCustomerCode: any;
    }
}

const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;


const Book = ({ responseStatus, errorDescription, schedulingConfig, fields: serverFields, token }: BookProps) => {

    const [loadingExternalLib, setLoadingExternalLib] = useState(true);

    useEffect(() => {
        const checkInterval = setInterval(() => {
            /* @ts-ignore-next-line */
            if (window && window?.google) {
                setLoadingExternalLib(false);
                clearInterval(checkInterval);
            }
        }, 3000);

        return () => {
            clearInterval(checkInterval);
        };
    }, []);

    return (
        <>
            <Head>
                <title>Agendamento - Fotop Serviços</title>
            </Head>

            <Script src={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places`} />

            {!loadingExternalLib ? (
                <>
                    <PoweredByHeader organizationLogo={serverFields?.logoUrl}/>
                    <BookingByTokenPage
                        responseStatus={responseStatus}
                        errorDescription={errorDescription}
                        token={token}
                        fields={serverFields}
                        schedulingConfig={schedulingConfig}
                    />
                </>
            ) : (
                <div className="container">
                    <div className="mt-30 text-center">
                        <Spinner />
                    </div>
                </div>
            )}
        </>
    );
};

Book.getInitialProps = async (ctx: NextPageContext): Promise<BookProps> => {
    const token = ctx.query.t as string;
    if (!token) {
        return {
            token,
            responseStatus: "error",
            errorDescription: "Url inválida. Token de agendamento não foi encontrado",
            fields: null,
            schedulingConfig: null
        };
    }

    return fetchScheduleConfig(token).then(result => ({
        token,
        responseStatus: result.responseStatus,
        errorDescription: result.errorDescription,
        fields: result?.data?.fields,
        schedulingConfig: result?.data?.schedulingConfig
    }));
};

export default Book;
